
// ? my current Implementation
import './CvTheque.scss';

import { Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { buttonStyles } from '../../../Components/docsAdministrative/JsObjectStyles';
import useRole from '../../../hooks/useRole';
import { isUrlFromRechercheAvance } from '../../../Utils/utils';

function CvTheque() {
    const {pathname} = useLocation();
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    const role=useRole();
    return (
        <>
            <div className='frame5Profile'>
                {i18n.t('CVThèque')} &gt;
                <span style={{ color: 'rgba(39, 45, 60, 1)' }}>
                    {i18n.t('Trouver des CV')}
                </span>
            </div>
            <div className='frame2CvTheque'>
                <div className='frame26CvTheque'>
                    <div className='frame27CvTheque'>
                        <Button
                            className='frame31CvTheque'
                            onClick={() =>
                            {
                                navigate(`/${role}/cvTheque`);
                            }}
                            style={
                                isUrlFromRechercheAvance(pathname) != true    ?
                                    {...buttonStyles(),...{
                                        background: '#E7EAF9',
                                        color: '#214DCE',
                                        borderRadius:'40px',
                                    }}:
                                    {...buttonStyles(),...{
                                        color: '#475063',
                                        borderRadius:'40px',
                                    }}
                            }
                            //style={
                            //    isUrlFromRechercheAvance(pathname) != true  ?
                            //        selectedFrameCvTheque:
                            //        notSelectedFrameCvTheque
                            //}
                            //{rechercheRapide &&
                            //    style={{background:'#E7EAF9'}}
                            //}
                        >
                            {i18n.t('Recherche Rapide')}
                        </Button>
                        <Button
                            className='frame31CvTheque'
                            onClick={() =>
                            {
                                navigate(`/${role}/cvTheque/advanced`);
                            }}
                            style={
                                isUrlFromRechercheAvance(pathname) == true ?
                                    {...buttonStyles(),...{
                                        background: '#E7EAF9',
                                        color: '#214DCE',
                                        borderRadius:'40px',
                                    }}:
                                    {...buttonStyles(),...{
                                        color: '#475063',
                                        borderRadius:'40px',
                                    }}
                            }
                            //style={
                            //    isUrlFromRechercheAvance(pathname) == true  ?
                            //        selectedFrameCvTheque:
                            //        notSelectedFrameCvTheque
                            //}
                        >
                            {i18n.t('Recherche Avancée')}
                        </Button>
                    </div>
                </div>
                <h4 className='titlesociete'>{i18n.t('Trouver des CV')}</h4>
                {/* //TODO use Tabs, better for performance [srtt mobile devices] */}
                <Outlet/>
            </div>
        </>
    );
}

export default CvTheque;
